module.exports = __webpack_public_path__ + "static/media/specs2.684f27fd.png";